import { render, staticRenderFns } from "./header-layout-catalogue.vue?vue&type=template&id=de3cb290&scoped=true&"
import script from "./header-layout-catalogue.vue?vue&type=script&lang=js&"
export * from "./header-layout-catalogue.vue?vue&type=script&lang=js&"
import style0 from "./header-layout-catalogue.vue?vue&type=style&index=0&id=de3cb290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3cb290",
  null
  
)

export default component.exports